import { Children } from 'react';

var validators = {
  ONCE: function ONCE(types, i, type) {
    return types[i] && types[i].type === type ? i + 1 : false;
  },

  OPTIONAL: function OPTIONAL(types, i, type) {
    return types[i] && types[i].type === type ? i + 1 : i;
  },

  ANY: function ANY(types) {
    return types.length;
  },

  MULTIPLE: function MULTIPLE(types, i, type) {
    if (!types[i] || types[i].type !== type) {
      return false;
    }
    while (types[i] && types[i].type === type) {
      ++i;
    }
    return i;
  }
};

var error = function error(componentName, rules) {
  var orderedTypes = rules.map(function (rule) {
    return rule.validation === 'ANY' ? '* (' + rule.validation + ')' : rule.type.name + ' (' + rule.validation + ')';
  }).join(', ');
  return new Error(componentName + ' should have children of the following types in this order: ' + orderedTypes);
};

export var once = function once(type) {
  return { validation: 'ONCE', type: type };
};
export var optional = function optional(type) {
  return { validation: 'OPTIONAL', type: type };
};
export var multiple = function multiple(type) {
  return { validation: 'MULTIPLE', type: type };
};
export var any = function any() {
  return { validation: 'ANY' };
};

export var children = function children() {
  for (var _len = arguments.length, rules = Array(_len), _key = 0; _key < _len; _key++) {
    rules[_key] = arguments[_key];
  }

  return function (props, propName, componentName) {
    if (!rules || rules.length === 0) {
      return new Error(componentName + ' should have at least a single child declaration rule');
    }
    var childrenAsArray = Children.toArray(props[propName]);
    var result = rules.reduce(function (acc, curr) {
      if (acc === false) {
        return acc;
      }
      return validators[curr.validation](childrenAsArray, acc, curr.type);
    }, 0);
    if (result === false || childrenAsArray[result]) {
      return error(componentName, rules);
    }
  };
};
//# sourceMappingURL=CompositeValidation.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Composite/CompositeValidation.js